import { createReducer } from '@reduxjs/toolkit'
import { TargetVariables } from 'interfaces/api/promoSettings.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createAllTargetVariables,
  getAllTargetVariables,
  removeTargetVariable,
  setTargetVariablesValidationErrors,
  updateTargetVariable,
} from './actions'

interface PromoTargetVariablesState {
  list: {
    loading: boolean
    items: TargetVariables
  }
  single: {
    loading: boolean
    item: string | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: PromoTargetVariablesState = {
  list: {
    loading: false,
    items: {
      variable: [],
      direction: [],
    },
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const promoTargetVariablesReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllTargetVariables.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllTargetVariables.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllTargetVariables.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setTargetVariablesValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase(
      [createAllTargetVariables.pending, removeTargetVariable.pending, updateTargetVariable.pending],
      (state) => {
        state.list.loading = true
      },
    )
    .addCase(
      [createAllTargetVariables.rejected, removeTargetVariable.rejected, updateTargetVariable.rejected],
      (state) => {
        state.list.loading = false
      },
    )
    .addCase(
      [createAllTargetVariables.fulfilled, removeTargetVariable.fulfilled, updateTargetVariable.fulfilled],
      (state) => {
        state.list.loading = false
      },
    )
})
